<ng-container *ngIf="isLoggedIn; else notLoggedIn">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #notLoggedIn>
  <div *ngIf="!authenticating"
       class="application-common-container full-screen-center">
    <button class="login-button"
            (click)="onLoginClicked()">LOGIN</button>
  </div>
  <div *ngIf="authenticating"
       class="application-common-container full-screen-center authenticating-loader">
    <div class="centered-content"> AUTHENTICATING <mat-progress-bar mode="buffer"></mat-progress-bar>
    </div>
  </div>
</ng-template>